export const parseAppMasterData = (appMasterData) => ({
    "l_list": [
        "en",
        "hi"
    ],
    "default_lang": appMasterData.d_lang,
    "currency": appMasterData.cur,
    "int_version": appMasterData.int_v,
    "coin_only": appMasterData.c_only,
    "c_point": appMasterData.c_pt,
    "vc_point": appMasterData.vc_pt,
    "a_teams": appMasterData.a_tms,
    "login_flow": appMasterData.l_flow,
    "a_collection": appMasterData.a_clcn,
    "auto_kyc_enable": appMasterData.auto_kyc,
    "allow_auto_withdrawal": appMasterData.a_auto_w,
    "pg": {
        "credit_debit_card": appMasterData.pg.cc_dc,
        "wallet": appMasterData.pg.w,
        "upi": appMasterData.pg.upi,
        "net_banking": appMasterData.pg.nb
    },
    "min_withdrawal": appMasterData.min_w,
    "max_withdrawal": appMasterData.max_w,
    "currency_code": appMasterData.c_code,
    "app_cache_version": appMasterData.app_c_v,
    "private_contest": appMasterData.c_pt,
    "a_pan_flow": appMasterData.a_p_flow,
    "a_bank_flow": appMasterData.a_b_flow,
    "a_deal": appMasterData.a_deal,
    "a_age_limit": appMasterData.a_age_l,
    "a_free_to_play": appMasterData.a_f_t_play,
    "max_contest_bonus": appMasterData.max_ct_b,
    "hub_icon": appMasterData.hub_icon,
    "a_hub_icon": appMasterData.a_hub_icon,
    "hub_banner": appMasterData.hub_bnr,
    "a_hub_banner": appMasterData.a_hub_bnr,
    "prize_bnr": appMasterData.prize_bnr,
    "a_prize_bnr": appMasterData.a_prize_bnr,
    "sports_prediction_bnr": appMasterData.sp_bnr,
    "a_sports_prediction_bnr": appMasterData.a_sp_bnr,
    "dfs_bnr": appMasterData.dfs_bnr,
    "a_dfs_bnr": appMasterData.a_dfs_bnr,
    "app_version": parseAppVersion(appMasterData.app_v),
    "private_contest": appMasterData.p_ct,
    // "allow_google": appMasterData.a_ggl,
    "login_data": appMasterData.l_data,
    "fantasy_list": parseFantasyList(appMasterData.new_f_list),
    "default_sport": appMasterData.d_sport,
    "banner": appMasterData.bnr ? parseBanner(appMasterData.bnr) : appMasterData.bnr,
    "bg_image": appMasterData.bg_img,
    "m_e_p_b": appMasterData.m_e_p_b,
    "banned_state": appMasterData.b_state,
    "a_coin": appMasterData.a_coin,
    "a_prediction": appMasterData.a_prdtn,
    "min_bet_coins": appMasterData.min_b_c,
    "max_bet_coins": appMasterData.max_b_c,
    "sports_hub": appMasterData.sports_hub,
    "min_dep": appMasterData.min_dep
});

const parseAppVersion = (appversion) => {
    return {
        "android": {
            "min_ver": appversion.android.m_v,
            "current_ver": appversion.android.c_v,
            "app_url": appversion.android.u,
            "msg": appversion.android.msg
        },
        "ios": {
            "min_ver": appversion.ios.m_v,
            "current_ver": appversion.ios.c_v,
            "app_url": appversion.ios.u,
            "msg": appversion.ios.msg,
        }
    }
}
const parseFantasyList = (fantasyList) => {
    return fantasyList.map((fantasyItem) => ({
        "team_player_count": fantasyItem.tpc,
        "sports_id": fantasyItem.sid,
        "sports_name": fantasyItem.sname,
        "en": fantasyItem.en,
        "hi": fantasyItem.hi
    }))
}
const parseBanner = (banner) => {
    return {
        "app_banner_id": banner.id,
        "banner_title": banner.ttle,
        "banner_image": banner.img,
        "banner_link": banner.link
    }
}

const getAllowedSportsId = (flist) => {
    return flist.map(fItem => fItem.sid);
}